import { render, staticRenderFns } from "./select-goods-card.vue?vue&type=template&id=613fcc5f&scoped=true"
import script from "./select-goods-card.vue?vue&type=script&lang=js"
export * from "./select-goods-card.vue?vue&type=script&lang=js"
import style0 from "./select-goods-card.vue?vue&type=style&index=0&id=613fcc5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613fcc5f",
  null
  
)

export default component.exports